import { EventorTriggerHoverTime } from '../triggers/EventorTriggerHoverTime';
export class EventorTriggers {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get app() {
        return this.parent.app;
    }
    hovertime = new EventorTriggerHoverTime(this);
}
